import i18n from '@/i18n'

/**
 * Has permission
 *
 * @param {Object} options
 * @param {Object} options.store Needed for permission check, store holds the user permissions
 * @param {Object} [options.router = null] Vue router, Check permissions before route if present
 *
 * Vue Router
 * If you apply a permission array to a route meta, check the permissions of the user against it
 *
 * {
 *  path: '',
 *  name: 'paymentJobsOverview',
 *  component: "PaymentJobsOverview",
 *  meta: {
 *    permissions: ['Portal.PaymentJobs.Read', 'Portal.PaymentJobs.Post']
 *  }
 *}
 *
 * Global functions
 * If you want to hide specific html / Vue components.
 *
 * Value: permission e.g. 'Portal.Customers.Read' or permissions e.g. ['Portal.Customers.Read', 'Portal.Customers.Create']
 *
 * How to hide a component(s) / element(s)
 *
 * <div v-if="$hasPermission('Portal.Customers.Read')">
 * <div v-if="$hasPermissions(['Portal.Customers.Read', 'Portal.Customers.Create'])">
 *
 * If you want to check if a user have one or more permissions
 * <div v-if="$hasAnyPermissions(['Portal.Customers.Update', 'Portal.Customers.Create'])">
 */
export default {
  install: function (Vue, { store, router = null }) {
    const hasPermission = permission => store.state.authorization.permissions.includes(permission)

    const hasPermissions = permissions => permissions.every(permission => hasPermission(permission))

    const hasAnyPermissions = permissions => permissions.some(permission => hasPermission(permission))

    if (router) {
      router.beforeEach((to, from, next) => {
        const metas = to.matched
          .filter(route => route.meta && route.meta.permissions)
          .map(route => route.meta)

        if (metas.every(meta => hasPermissions(meta.permissions))) {
          next()
        } else {
          console.warn(`Name: ${to.name}, Path: ${to.path}, Permissions: ${metas.map(item => item.permissions.join()).join()}`)
          store.dispatch('showMessage', { title: i18n.t('sentence.noPermissions'), options: { variant: 'danger' } })
          next({ name: 'notFound' })
        }
      })
    }

    Object.defineProperties(Vue.prototype, {
      '$hasPermission': {
        get () {
          return hasPermission
        }
      },
      '$hasPermissions': {
        get () {
          return hasPermissions
        }
      },
      '$hasAnyPermissions': {
        get () {
          return hasAnyPermissions
        }
      }
    })
  }
}
